import { useState, useEffect, useCallback } from 'react';
import { supabase } from '../supabaseClient';

export const useSavedSearches = () => {
  const [searches, setSearches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchAll = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const { data, error: err } = await supabase
        .from('saved_searches')
        .select('*')
        .order('updated_at', { ascending: false });
      if (err) throw err;
      setSearches(data || []);
    } catch (err) {
      console.error('useSavedSearches:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchAll(); }, [fetchAll]);

  const createSearch = async (payload, userEmail) => {
    const { data, error: err } = await supabase.from('saved_searches').insert({
      ...payload,
      owner_email: userEmail,
      created_by: userEmail,
      updated_by: userEmail,
    }).select('*').single();
    if (err) return { success: false, error: err.message };
    await fetchAll();
    return { success: true, data };
  };

  const updateSearch = async (id, patch, userEmail) => {
    const { error: err } = await supabase
      .from('saved_searches')
      .update({ ...patch, updated_by: userEmail, updated_at: new Date().toISOString() })
      .eq('id', id);
    if (err) return { success: false, error: err.message };
    await fetchAll();
    return { success: true };
  };

  const deleteSearch = async (id) => {
    if (!window.confirm('Arquivar esta audiência? Histórico de runs será preservado.')) return { success: false };
    const { error: err } = await supabase.from('saved_searches').delete().eq('id', id);
    if (err) return { success: false, error: err.message };
    await fetchAll();
    return { success: true };
  };

  const duplicateSearch = async (source, userEmail) => {
    const payload = {
      name: `${source.name} (cópia)`,
      description: source.description,
      search_target: source.search_target,
      filters: source.filters,
      owner_email: userEmail,
      is_shared: false,
      is_template: false,
      auto_enrich_top_n: source.auto_enrich_top_n || 0,
      created_by: userEmail,
      updated_by: userEmail,
    };
    const { data, error: err } = await supabase.from('saved_searches').insert(payload).select('*').single();
    if (err) return { success: false, error: err.message };
    await fetchAll();
    return { success: true, data };
  };

  return { searches, loading, error, refetch: fetchAll, createSearch, updateSearch, deleteSearch, duplicateSearch };
};
